export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Kokonaiskuvat luotu',
        cost: 'Hinta',
        imagesPerDay: 'Kuvia / päivä',
    },
};
